import { render, staticRenderFns } from "./TooltipItemTable.vue?vue&type=template&id=3f46168c&scoped=true&"
import script from "./TooltipItemTable.vue?vue&type=script&lang=js&"
export * from "./TooltipItemTable.vue?vue&type=script&lang=js&"
import style0 from "./TooltipItemTable.vue?vue&type=style&index=0&id=3f46168c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f46168c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
